import { PhosphorCaretLeftAnchor } from "components/Atoms/PhosphorIconAnchor";
import { PhosphorCaretLeftButton } from "components/Atoms/PhosphorIconButton";
import React from "react";

interface Props {
  url: string | undefined
}

const ArrowLeft = ({ url }: Props) => {
  if (url) {
    return <PhosphorCaretLeftAnchor
      layout="in-square"
      href={url} />;
  }

  return <PhosphorCaretLeftButton
    layout="in-square"
    disabled={true} />;
};

export default ArrowLeft;
